import React from "react";
import { default as MUICard } from "@mui/material/Card";
import styled from "styled-components";

const StyledMUICard = styled(MUICard)`
  border-radius: 16px !important;
  box-shadow:
    0px 3px 5px -1px rgba(60, 71, 95, 0.2),
    0px 5px 8px rgba(60, 71, 95, 0.14),
    0px 1px 14px rgba(60, 71, 95, 0.12) !important;
`;

export const Card = (props) => {
  return <StyledMUICard {...props} />;
};
